import { TrackingAction, TrackingPage } from "../types";

const getEventName = (page: TrackingPage, action: TrackingAction) => `${page}_${action}`;

export default getEventName